export default __webpack_public_path__ + "static/media/untrusted.0872576a.png";